// src/js/components/cookieBanner.js

export function initializeCookieBanner() {
    const banner = document.getElementById('cookie-consent-banner');
    if (!banner) return;

    const acceptBtn = document.getElementById('cookie-accept-btn');
    const declineBtn = document.getElementById('cookie-decline-btn');
    if (!acceptBtn || !declineBtn) {
        console.warn('Cookie banner hittades, men accepteraknapp eller avböjknapp saknas.');
        return;
    }

    const CONSENT_COOKIE_NAME = 'cookie_consent_choice';
    const COOKIE_EXPIRATION_DAYS = 180;

    const hideBanner = () => {
        if (banner) banner.classList.remove('is-visible');
    };
    const showBanner = () => {
        if (banner) banner.classList.add('is-visible');
    };

    const setCookie = (name, value, days) => {
        let expires = "";
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = `${name}=${value || ""}${expires}; path=/; SameSite=Lax`;
    };

    const getCookie = (name) => {
        const nameEQ = name + "=";
        const ca = document.cookie.split(';');
        for(let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    };

    const handleConsent = (choice) => {
        setCookie(CONSENT_COOKIE_NAME, choice, COOKIE_EXPIRATION_DAYS);
        hideBanner();

        if (typeof gtag === 'function') {
            const consentState = choice === 'accepted' ? 'granted' : 'denied';
            gtag('consent', 'update', {
                'analytics_storage': consentState
            });
            console.log(`Cookie consent ${choice}. Google Analytics tracking set to ${consentState}.`);
        }
    };

    acceptBtn.addEventListener('click', () => handleConsent('accepted'));
    declineBtn.addEventListener('click', () => handleConsent('declined'));

    if (!getCookie(CONSENT_COOKIE_NAME)) {
        showBanner();
    }

    console.log('Cookie Banner initialized.');
}